export default __webpack_public_path__ + "static/media/img5.06a2cdce.png";